import { supabase } from "./supabase";

// Fala com os módulos sobre o CLIENTE — consultar e cadastrar.
//
// Nunca lança: qualquer falha volta como { error }, para a tela mostrar o
// aviso e a adesão continuar valendo. A integração é conveniência; o registro
// do CRM funciona sem ela.

async function chamar(corpo) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    if (!token) return { error: "Sessão expirada — entre de novo." };
    const r = await fetch("/api/cliente-modulo", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(corpo),
    });
    return await r.json().catch(() => ({ error: "Resposta inesperada do servidor." }));
  } catch {
    return { error: "Falha de conexão." };
  }
}

export const consultarCliente = (sistema, documento) => chamar({ sistema, documento });

export const cadastrarCliente = (sistema, cliente) => chamar({
  sistema,
  acao: "cadastrar",
  documento: cliente.cnpj,
  razaoSocial: cliente.razaoSocial,
  nomeFantasia: cliente.company,
  responsavel: cliente.contact,
  email: cliente.email,
  telefone: cliente.phone,
  cidade: cliente.cidade,
  estado: cliente.estado,
  tipo: cliente.tipoCliente,
});

/** O que o módulo respondeu, no formato que o cliente do CRM guarda. */
export function respostaParaSync(sistema, r) {
  const ts = new Date().toISOString();
  if (!r || r.error) return { [sistema]: { ok: false, erro: r?.error || "falha desconhecida", ts } };
  if (r.configured === false) return { [sistema]: { ok: false, erro: "integração não configurada neste ambiente", ts } };
  if (!r.found) return { [sistema]: { ok: false, erro: r.invalid ? "documento recusado pelo módulo" : "não encontrado", ts } };
  return {
    [sistema]: {
      ok: true, ts,
      client_id: r.client_id,
      plano: r.plano || null,
      veiculos: r.veiculos ?? null,
      rastreadores_instalados: r.rastreadores_instalados ?? null,
      operando: !!r.operando,
      pendencias: r.pendencias || [],
    },
  };
}
